/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommunityItemMinimal } from '../../models/community-item-minimal';

export interface CommunityControllerProfilePicture$Params {
  id: number;
      body: {
'picture'?: Blob;
}
}

export function communityControllerProfilePicture(http: HttpClient, rootUrl: string, params: CommunityControllerProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerProfilePicture.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommunityItemMinimal;
      }>;
    })
  );
}

communityControllerProfilePicture.PATH = '/community/{id}/picture';
